import { FC } from 'react';
import { Stack, Typography, SxProps, Theme } from '@mui/material';

interface DealSidePanelItemProps {
  label: string;
  value: string;
  bold?: boolean;
  sx?: SxProps<Theme>;
}

const DealSidePanelItem: FC<DealSidePanelItemProps> = ({ label, value, bold = false, sx = {} }) => {
  return (
    <Stack gap={'0.5rem'} sx={sx}>
      <Typography fontSize={12} lineHeight={'1rem'} fontWeight={bold ? 700 : 500} color={'#6C6C6C'}>
        {label}
      </Typography>
      <Typography
        fontSize={16}
        lineHeight={'22px'}
        fontWeight={bold ? 700 : 500}
        color={'#162936'}
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {value}
      </Typography>
    </Stack>
  );
};

export default DealSidePanelItem;
